<script lang="ts" setup>
import { getAcronym } from '~/utils/baseUtils';
import { UserAvatarProps } from './_types';

const props = withDefaults(defineProps<UserAvatarProps>(), {
    size: '3.5rem',
    fontSize: '1.125rem',
    color: 'primary',
    bgColor: 'on-primary',
});

const textColor = computed(() => `text-${props.color}`);
const bgColor = computed(() => `bg-${props.bgColor}`);
</script>

<template>
    <q-avatar class="app-user-avatar" :size="size" :font-size="fontSize">
        <div class="full-width full-height row justify-center items-center text-bold" :class="[textColor, bgColor]">
            <span>{{ getAcronym(fullName) }}</span>
        </div>
    </q-avatar>
</template>
